import { render, staticRenderFns } from "./ManageDelivery.vue?vue&type=template&id=2f336d0d&scoped=true"
import script from "./ManageDelivery.vue?vue&type=script&lang=js"
export * from "./ManageDelivery.vue?vue&type=script&lang=js"
import style0 from "./ManageDelivery.vue?vue&type=style&index=0&id=2f336d0d&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f336d0d",
  null
  
)

export default component.exports